import * as moment from 'moment';

export const FrequencyTypes = [
	{
		label: 'Minutes',
		value: '1',
	},
	{
		label: 'Hours',
		value: '2',
	},
	{
		label: 'Days',
		value: '3',
	},
];

export const FrequencyTypes_old = [
	{
		label: 'Seconds',
		value: '1',
	},
	{
		label: 'Minutes',
		value: '2',
	},
	{
		label: 'Hours',
		value: '3',
	},
	{
		label: 'Days',
		value: '4',
	},
	{
		label: 'Weeks',
		value: '5',
	},
	{
		label: 'Months',
		value: '6',
	},
	{
		label: 'Weekdays',
		value: '7',
	},
	{
		label: 'Weekdays',
		value: '8',
	},
];

export const dateFunctionOptions = [
	{
		label: 'No Transform',
		value: 'NoTransform',
	},
	{
		label: 'Year',
		value: 'Year',
	},
	{
		label: 'Month',
		value: 'Month',
	},
	{
		label: 'Date',
		value: 'Day',
	},
	{
		label: 'Day',
		value: 'WeekDay',
	},
	{
		label: 'Days Passed',
		value: 'DaysPassed',
	},
	{
		label: 'Hours Passed',
		value: 'HoursPassed',
	},
	{
		label: 'Minutes Passed',
		value: 'MinutesPassed',
	},
];

export const monthsTransform = [
	{
		label: 'January',
		value: '1',
	},
	{
		label: 'February',
		value: '2',
	},
	{
		label: 'March',
		value: '3',
	},
	{
		label: 'April',
		value: '4',
	},
	{
		label: 'May',
		value: '5',
	},
	{
		label: 'June',
		value: '6',
	},
	{
		label: 'July',
		value: '7',
	},
	{
		label: 'August',
		value: '8',
	},
	{
		label: 'September',
		value: '9',
	},
	{
		label: 'October',
		value: '10',
	},
	{
		label: 'November',
		value: '11',
	},
	{
		label: 'December',
		value: '12',
	},
];

export const daysTransform = [
	{
		label: '1st',
		value: '1',
	},
	{
		label: '2nd',
		value: '2',
	},
	{
		label: '3rd',
		value: '3',
	},
	{
		label: '4th',
		value: '4',
	},
	{
		label: '5th',
		value: '5',
	},
	{
		label: '6th',
		value: '6',
	},
	{
		label: '7th',
		value: '7',
	},
	{
		label: '8th',
		value: '8',
	},
	{
		label: '9th',
		value: '9',
	},
	{
		label: '10th',
		value: '10',
	},
	{
		label: '11th',
		value: '11',
	},
	{
		label: '12th',
		value: '12',
	},
	{
		label: '13th',
		value: '13',
	},
	{
		label: '14th',
		value: '14',
	},
	{
		label: '15th',
		value: '15',
	},
	{
		label: '16th',
		value: '16',
	},
	{
		label: '17th',
		value: '17',
	},
	{
		label: '18th',
		value: '18',
	},
	{
		label: '19th',
		value: '19',
	},
	{
		label: '20th',
		value: '20',
	},
	{
		label: '21th',
		value: '21',
	},
	{
		label: '22th',
		value: '22',
	},
	{
		label: '23th',
		value: '23',
	},
	{
		label: '24th',
		value: '24',
	},
	{
		label: '25th',
		value: '25',
	},
	{
		label: '26th',
		value: '26',
	},
	{
		label: '27th',
		value: '27',
	},
	{
		label: '28th',
		value: '28',
	},
	{
		label: '29th',
		value: '29',
	},
	{
		label: '30th',
		value: '30',
	},
	{
		label: '31st',
		value: '31',
	},
];

export const weekTransform = [
	{
		label: 'Sunday',
		value: '0',
	},
	{
		label: 'Monday',
		value: '1',
	},
	{
		label: 'Tuesday',
		value: '2',
	},
	{
		label: 'Wednesday',
		value: '3',
	},
	{
		label: 'Thursday',
		value: '4',
	},
	{
		label: 'Friday',
		value: '5',
	},
	{
		label: 'Saturday',
		value: '6',
	},
];
